import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import moment from "moment";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Input,
  SelectInput,
  RenderInputFields,
  SubmitButton,
  ReactSelectInput,
  PhoneNumber,
} from "../Form/Form";
import { API } from "../../constant/api";

const apiName = "user";
const titleSingular = "Customer";
const titlePlural = "Customers";

const Edit = (props) => {
  const { id } = props.match.params;
  const history = useHistory();
  const imgArray = ["image/png", "image/jpeg", "image/jpg"];

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm();

  const { response: responseFetchUser, request: requestFetchSeeker } =
    useRequest();

  const { response, request } = useRequest();

  const [image, setImage] = useState("");
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);

  useEffect(() => {
    if (id) {
      requestFetchSeeker("GET", `${apiName}/${id}`);
      document.title = `Edit ${titleSingular} - Easyspare`;
    }
  }, [id]);

  useEffect(() => {
    if (responseFetchUser) {
      const {
        firstName,
        lastName,
        contact,
        countryCode,
        profilePic,
        email,
        dob,
      } = responseFetchUser.user;
      if (profilePic) {
        setImage(`${API.PORT}/${profilePic}`);
      }
      setValue("firstName", firstName);
      setValue("lastName", lastName);
      setValue("contact", countryCode+""+contact);
      setValue("countryCode", countryCode);
      setValue("email", email);
      // setValue("dob", moment(dob).format("YYYY-MM-DD"));
      // setValue("dob", moment(dob).format("YYYY-MM-DD"));
    }
  }, [responseFetchUser]);

  useEffect(() => {
    if (response) {
      toast.success("Customer has been updated successfully.");
      history.push("/customers");
    }
  }, [response]);

  const displayImageHandler = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
    setIsProfilePicRemove(false);
  };
  const handleRemoveMedia = () => {
    setIsProfilePicRemove(true);
    setValue("profilePic", "");
    setImage("");
  };

  const onSubmit = (data) => {
    let { firstName, lastName, email, contact, countryCode, profilePic, dob } =
      data;

    if (dob == "Invalid date") {
      dob = "";
    }

    if (email) {
      email = email.toLowerCase();
    }
    const formData = new FormData();
    formData.append("lastName", lastName);
    formData.append("firstName", firstName);
    formData.append("email", email);
    formData.append("contact", contact.replace(countryCode, ""));
    formData.append("countryCode", countryCode);
    // formData.append("dob", dob);
    formData.append("id", id);
    formData.append("isProfilePicRemove", isProfilePicRemove);

    if (profilePic && profilePic[0]) {
      const profilePicType = profilePic[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select inage only in profile pic");
        return;
      } else {
        formData.append("profilePic", profilePic[0]);
      }
    }

    request("PUT", apiName, formData);
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "First Name",
        type: "text",
        name: "firstName",
        registerFields: {
          required: true,
          // pattern: /^[A-Za-z ]+$/,
          onChange: (v) =>
            setValue("firstName", v.target.value.replace(/[^a-zA-Z]/g, "")),
        },
        // registerFieldsFeedback: {
        //   pattern: "First name can only contain letters.",
        // },
      },
      {
        Component: Input,
        label: "Last Name",
        type: "text",
        name: "lastName",
        registerFields: {
          required: true,
          onChange: (v) =>
            setValue("lastName", v.target.value.replace(/[^a-zA-Z]/g, "")),
          // pattern: /^[A-Za-z ]+$/,
        },
        // registerFieldsFeedback: {
        //   pattern: "Last name can only contain letters.",
        // },
      },
      {
        Component: Input,
        label: "Email",
        type: "email",
        name: "email",
        registerFields: {
          required: true,
          pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          setValueAs: (v) => v.trim(),
        },
        registerFieldsFeedback: {
          pattern: "The email field must be a valid email address.",
        },
      },
      {
        Component: PhoneNumber,
        label: "Contact",
        type: "number",
        name: "contact",
        control: control,
        setValue: setValue,
        registerFields: {
          required: true,
          pattern: {
            value: /^[0-9][0-9]{7,14}$/,
          },
        },
        registerFieldsFeedback: {
          pattern: "Please enter valid 8-15 digit contact number.",
        },
      },
      // {
      //   Component: Input,
      //   label: "DOB",
      //   type: "date",
      //   name: "dob",
      //   isDate: true,
      //   control: control,
      //   max: new Date().toISOString().split("T")[0],
      //   min: "1970-01-01",
      //   registerFields: {
      //     required: false,
      //   },
      // },

      // {
      //   Component: Input,
      //   label: "DOB",
      //   type: "date",
      //   name: "dob",
      //   registerFields: {
      //     required: false,
      //     // setValueAs: (v) => v.trim(),
      //   },
      //   inputData: {
      //     max: moment().format("YYYY-MM-DD"),
      //   },
      //   registerFieldsFeedback: {
      //     // pattern: "The zip code field must be a valid zip code.",
      //   },
      // },

      {
        Component: Input,
        label: "Profile Pic",
        type: "file",
        name: "profilePic",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image && (
          <>
            <img
              src={image}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit Customer"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: { pathname: "/customers" /*backPageNum: page */ },
            name: "Back To Customers",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Edit Customer</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <RenderInputFields
                      InputFields={InputFields}
                      errors={errors}
                      register={register}
                    />

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
